<template>
<div class="">
    <h2>
        Events Dashboard
    </h2>
    <button class="btn btn-danger signout-btn" @click="signOut">
        Sign Out
    </button>

    <AddEvent />

    <div class="col-md-12 row">
        <EventItem
            v-for="(event_item, index) in this.$store.state.events"
            :event="event_item"
            key="index"
        />
    </div>

    <!-- {{ $store.state.events }} -->
</div>
</template>

<script>
import { firebaseApp, eventsRef } from '../firebaseApp'
import AddEvent from './AddEvent.vue'
import EventItem from './EventItem.vue'

export default {
    methods: {
        signOut() {
            this.$store.dispatch('signOut')
            firebaseApp.auth().signOut()
        }
    },
    components: {
        AddEvent,
        EventItem
    },
    mounted() {
        eventsRef.on('value', snap => {
            let events = []

            snap.forEach(event => {
                events.push(event.val())
            })
            // console.log('events', events)
            this.$store.dispatch('setEvents', events)
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue